import React from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiHexagon, FiShield, FiTarget } from 'react-icons/fi';

export const Logo = ({ size = "md", className = "" }) => {
  const sizes = {
    sm: "w-8 h-8 text-xl",
    md: "w-10 h-10 text-2xl",
    lg: "w-14 h-14 text-4xl"
  };

  return (
    <div className={`relative flex items-center justify-center ${sizes[size]} ${className}`}>
      {/* Outer Glow */}
      <div className="absolute inset-0 bg-yellow-400/20 blur-lg rounded-full animate-pulse"></div>
      
      {/* Hexagon Frame */}
      <div className="relative z-10 text-yellow-400">
        <SafeIcon icon={FiHexagon} className="stroke-[1.5px]" />
      </div>
      
      {/* Inner Signal Point */}
      <div className="absolute inset-0 flex items-center justify-center z-20">
        <div className="w-1.5 h-1.5 bg-yellow-400 rounded-full shadow-[0_0_8px_#facc15]"></div>
        <div className="absolute w-4 h-4 border border-yellow-400/30 rounded-full animate-ping"></div>
      </div>
    </div>
  );
};

export const Avatar = ({ src, name, size = "md" }) => {
  const [error, setError] = React.useState(false);
  const initials = name?.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  
  const sizes = {
    sm: "w-8 h-8 text-[10px]",
    md: "w-10 h-10 text-xs",
    lg: "w-16 h-16 text-lg"
  };

  const colors = [
    'bg-blue-500/20 text-blue-400 border-blue-500/30',
    'bg-purple-500/20 text-purple-400 border-purple-500/30',
    'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    'bg-orange-500/20 text-orange-400 border-orange-500/30',
    'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
  ];

  const colorIndex = name ? name.length % colors.length : 0;

  if (!src || error) {
    return (
      <div className={`${sizes[size]} rounded-full border flex items-center justify-center font-bold tracking-tighter ${colors[colorIndex]}`}>
        {initials || '??'}
      </div>
    );
  }

  return (
    <div className={`${sizes[size]} rounded-full p-[2px] bg-gradient-to-tr from-yellow-400 to-orange-500`}>
      <img 
        src={src} 
        alt={name} 
        onError={() => setError(true)}
        className="w-full h-full rounded-full object-cover border-2 border-[#0A0F1C]"
      />
    </div>
  );
};

export const VendorIcon = ({ name, category }) => {
  const initials = name?.charAt(0).toUpperCase();
  return (
    <div className="w-10 h-10 rounded-lg bg-[#0F1626] border border-slate-700 flex items-center justify-center text-yellow-400 font-black text-xl shadow-inner group-hover:border-yellow-400/50 transition-colors">
      {initials}
    </div>
  );
};